import React, { useEffect, useState } from 'react';
import AutoItem from './AutoItem';
import AutoModal from './AutoModal';
import 'bootstrap/dist/css/bootstrap.min.css';

const ITEMS_PER_PAGE = 6;

const AutolistUsadosdos = () => {
  const [autos, setAutos] = useState([]);
  const [selectedAuto, setSelectedAuto] = useState(null);
  const [filterMarca, setFilterMarca] = useState('');
  const [filterModelo, setFilterModelo] = useState('');
  const [marcas, setMarcas] = useState([]);
  const [modelos, setModelos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const fetchAutos = async () => {
      setLoading(true);
      setError('');
      try {
        const response = await fetch('https://jpmotorsapi.jpmotorsgt.com/vehiculos/usados');
        if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);
        const data = await response.json();
        setAutos(data);
        setMarcas([...new Set(data.map(auto => auto.Marca))]);
        setModelos([...new Set(data.map(auto => auto.Modelo))]);
      } catch (err) {
        console.error("Error en la consulta a la API:", err);
        setError("Ocurrió un error al cargar los vehículos usados.");
      } finally {
        setLoading(false);
      }
    };

    fetchAutos();
  }, []);

  useEffect(() => {
    const modelosFiltrados = autos
      .filter(auto => !filterMarca || auto.Marca === filterMarca)
      .map(auto => auto.Modelo);
    setModelos([...new Set(modelosFiltrados)]);
    setFilterModelo('');
    setCurrentPage(1);
  }, [filterMarca, autos]);

  const filteredAutos = autos.filter(auto =>
    (!filterMarca || auto.Marca === filterMarca) &&
    (!filterModelo || auto.Modelo === filterModelo)
  );

  const totalPages = Math.ceil(filteredAutos.length / ITEMS_PER_PAGE);
  const paginatedAutos = filteredAutos.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const handleItemClick = (auto) => {
    if (auto?.VehiculoID) setSelectedAuto(auto);
  };

  return (
    <div className="container-xl">
      <h1 className="my-4 text-center">Lista de Vehículos Usados</h1>

      <div className="mb-4 d-flex justify-content-center gap-3">
        <div className="form-group">
          <label htmlFor="filterMarca">Marca</label>
          <select
            id="filterMarca"
            value={filterMarca}
            onChange={(e) => setFilterMarca(e.target.value)}
            className="form-control"
          >
            <option value="">Todas las Marcas</option>
            {marcas.map(marca => (
              <option key={marca} value={marca}>{marca}</option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="filterModelo">Modelo</label>
          <select
            id="filterModelo"
            value={filterModelo}
            onChange={(e) => setFilterModelo(e.target.value)}
            className="form-control"
            disabled={!filterMarca}
          >
            <option value="">Todos los Modelos</option>
            {modelos.map(modelo => (
              <option key={modelo} value={modelo}>{modelo}</option>
            ))}
          </select>
        </div>
      </div>

      {loading ? (
        <div className="text-center">
          <div className="spinner-border text-primary" role="status"></div>
          <p className="mt-2">Cargando vehículos usados...</p>
        </div>
      ) : error ? (
        <div className="alert alert-danger text-center">{error}</div>
      ) : (
        <>
          <div className="row">
            {paginatedAutos.length > 0 ? (
              paginatedAutos.map(auto => (
                <AutoItem
                  key={auto.VehiculoID}
                  auto={auto}
                  onClick={() => handleItemClick(auto)}
                />
              ))
            ) : (
              <p className="text-center">No se encontraron vehículos usados.</p>
            )}
          </div>

          {filteredAutos.length > ITEMS_PER_PAGE && (
            <div className="d-flex justify-content-center my-4">
              <button
                className="btn btn-outline-primary mx-2"
                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                Anterior
              </button>
              <span className="align-self-center">
                Página {currentPage} de {totalPages}
              </span>
              <button
                className="btn btn-outline-primary mx-2"
                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
              >
                Siguiente
              </button>
            </div>
          )}
        </>
      )}

      {selectedAuto && (
        <AutoModal
          auto={selectedAuto}
          onClose={() => setSelectedAuto(null)}
        />
      )}
    </div>
  );
};

export default AutolistUsadosdos;
